import rateTypesByDataset, {
    flatRateValue,
    sparkIndexValue,
} from '../models/RateTypes';
import { rateFormatterInstance } from '../formatters/RateFormatter';
import currencies from '../models/Currencies';
import { getAvailableBounds } from '../models/RateBounds';
import { getBalticRateIndicesByDatasetId } from '../models/BalticRateIndices';
import { durationUnits } from '../../../shared/columns/models/DurationUnits';
import { rateUnits, getAvailableUnits } from '../models/RateUnits';
import { validateBound } from '../services/ValidationService';
import { getSparkRateIndicesByDatasetId } from '../models/SparkRateIndices';
import { getBalticRouteByValue, getInfoByValue } from '../models/BalticRoute';

const getRateIndex = (rateValue, datasetId) => {
    const { balticIndex, sparkIndex } = rateValue;

    if (balticIndex) {
        return getBalticRateIndicesByDatasetId(datasetId).find(
            (index) => index.value === balticIndex.index
        );
    }

    if (sparkIndex) {
        return getSparkRateIndicesByDatasetId(datasetId).find(
            (index) => index.value === sparkIndex.index
        );
    }

    return undefined;
};

export const convertRateToInputStateModel = (
    selectedRate,
    fixtureType,
    datasetId,
    selectedIndex,
    tankersGroupType
) => {
    const { flatRate, balticIndex, sparkIndex, duration } =
        selectedRate.rateValue;
    const typeObj = rateTypesByDataset(datasetId).find(
        (type) => type.value === selectedRate.rateValue.type
    );

    const amount =
        typeObj?.value === flatRateValue
            ? flatRate.amount
            : typeObj?.value === sparkIndexValue
            ? sparkIndex.amount
            : balticIndex.amount;
    const amountString = rateFormatterInstance.formatAmount(amount, true);
    const amountObj = amount && {
        from: amount.from,
        to: amount.to,
    };

    const currencyObj =
        flatRate && currencies.find((ccy) => ccy.value === flatRate.currency);

    const unitObj =
        flatRate &&
        getAvailableUnits(fixtureType, tankersGroupType, datasetId).find(
            (unit) => unit.value === flatRate.unit
        );

    let boundObj =
        flatRate &&
        getAvailableBounds(fixtureType).find(
            (bound) => bound.value === flatRate.bound
        );
    if (boundObj && !boundObj.value) boundObj = null;

    const indexObj = getRateIndex(selectedRate.rateValue, datasetId);

    const durationAmountString = duration
        ? rateFormatterInstance.formatAmount(duration.amount, true)
        : '';
    const durationAmountObj = duration
        ? {
              isSuccess: true,
              parsedValue: durationAmountString,
              from: duration.amount.from,
              to: duration.amount.to,
          }
        : null;

    const durationUnitObj = duration
        ? durationUnits.find((unit) => unit.value === duration.unit)
        : getDefaultDurationUnit();

    const balticRouteObj = flatRate?.balticRoute
        ? getBalticRouteByValue(flatRate.balticRoute)
        : null;
    const infoObj = flatRate?.info ? getInfoByValue(flatRate.info) : null;
    const isEquiv = flatRate?.isEquiv || false;

    return {
        selectedIndex: selectedIndex,
        isEditMode: true,
        bound: boundObj,
        currency: currencyObj === undefined ? null : currencyObj,
        unit: unitObj ?? rateUnits[1],
        amount: amountString,
        amountObj: amountObj,
        isAmountValid: true,
        isAmountDisabled: unitObj ? unitObj.shouldDisableAmount : false,
        isCurrencyDisabled: unitObj ? unitObj.shouldDisableCurrency : false,
        isBoundDisabled: unitObj ? unitObj.shouldDisableBound : false,
        isBoundValid:
            typeObj?.value === flatRateValue
                ? validateBound(amountString)
                : true,
        type: typeObj,
        index: indexObj,
        isIndexValid: !!indexObj,
        durationAmount: durationAmountString,
        durationAmountObj: durationAmountObj,
        durationUnit: durationUnitObj ?? getDefaultDurationUnit(),
        isDurationAmountValid: true,
        arePartsValid: true,
        isDurationDisabled: unitObj ? unitObj.shouldDisableDuration : false,
        balticRoute: balticRouteObj,
        info: infoObj,
        isEquiv: isEquiv,
    };
};

const getDefaultDurationUnit = () => {
    return durationUnits.find((unit) => unit.isDefaultRateUnit);
};
